import { combineReducers } from "@reduxjs/toolkit";
import signupMemberReducer from "../features/signupMemberSlice";
import signinMemberReducer from "../features/signinMemberSlice";
import labMemberReducer from "../features/labMemberSlice";
import { UpcomingLabTestsSlice } from "../features/upcomingLabTestsSlice";
import customersReducer from "../features/customersSlice";
import testsReducer from "../features/testsSlice";
import testParametersReducer from "../features/testParametersSlice";
import checkupsReducer from "../features/checkupsSlice";
import appointmentsReducer from "../features/appointmentsSlice";
import reportsReducer from "../features/reportsSlice";
import paymentsReducer from "../features/paymentsSlice";
import subscriptionsReducer from "../features/subscriptionsSlice";
import notificationsReducer from "../features/notificationsSlice";
import usersReducer from "../features/usersSlice";
import ocrReducer from "../features/ocrSlice";
import healthScoresReducer from "../features/healthScoresSlice";
import contentReducer from "../features/contentSlice";
import couponsReducer from "../features/couponsSlice";

const rootReducer = combineReducers({
  signupMember: signupMemberReducer,
  signinMember: signinMemberReducer,
  labMember: labMemberReducer,
  upcomingLabTests: UpcomingLabTestsSlice.reducer,
  customers: customersReducer,
  tests: testsReducer,
  testParameters: testParametersReducer,
  checkups: checkupsReducer,
  appointments: appointmentsReducer,
  reports: reportsReducer,
  payments: paymentsReducer,
  subscriptions: subscriptionsReducer,
  notifications: notificationsReducer,
  users: usersReducer,
  ocr: ocrReducer,
  healthScores: healthScoresReducer,
  content: contentReducer,
  coupons: couponsReducer,
});

export { rootReducer };